export default __webpack_public_path__ + "static/media/home-sleep-test.766451d5.svg";